<nav class="flex flex-column">
    <a
        *ngFor="let link of links; let last = last"
        [routerLink]="link.route"
        (click)="linkClick.emit()"
        class="flex align-items-center gap-3 py-3 text-900 no-underline"
        [ngClass]="last ? '' : 'border-bottom-1 surface-border'"
    >
        <i [class]="'ph ' + link.icon" style="font-size: 1.25rem;" aria-hidden="true"></i>
        <span class="flex-1 font-semibold">{{ link.label }}</span>
        <i class="ph ph-caret-right text-color-secondary" aria-hidden="true"></i>
    </a>

    <!-- An anchor, like the rows above: p-button does not carry routerLink
         through to the element that is actually clicked. -->
    <a
        *ngIf="upgradeLink"
        [routerLink]="upgradeLink"
        [queryParams]="upgradeParams"
        (click)="linkClick.emit()"
        class="flex align-items-center justify-content-center mt-3 no-underline font-bold border-round-3xl"
        style="min-height: 48px; background: #2e8bf8; color: #ffffff; font-size: 15px"
    >
        Go Premium+
    </a>
</nav>
